module.exports = __webpack_public_path__ + "img/valor_estagiario.07653e54.png";